import type { FC } from 'react';
import type { DeleteMeetingButtonProps } from '../../types';

const DeleteMeetingButton: FC<DeleteMeetingButtonProps> = ({ onDelete, isProcessing }) => (
  <button
    type="button"
    className="personal-meetings-modal__footer-button personal-meetings-modal__footer-button--delete"
    onClick={onDelete}
    disabled={isProcessing}
  >
    Delete
  </button>
);

export default DeleteMeetingButton;
